import React, { useState, useEffect } from 'react';
import { api, tomorrow } from '../api';

function firstOfMonth() { const d = new Date(); d.setDate(1); return d.toISOString().split('T')[0]; }

const MEAL_LABELS = { breakfast: '🥐 Завтрак', dinner: '🌙 Ужин', lunch: '🍲 Обед', other: '☕ Прочее' };
const MEAL_CLS   = { breakfast: 'meal-breakfast', dinner: 'meal-dinner', lunch: 'meal-lunch', other: 'meal-other' };
const HOTEL_COLORS = [
  ['#667eea','#764ba2'],['#f093fb','#f5576c'],['#4facfe','#00f2fe'],
  ['#43e97b','#38f9d7'],['#fa709a','#fee140'],['#a18cd1','#fbc2eb'],
];
function hotelColor(name) {
  let h = 0; for (let i=0;i<name.length;i++) h=(h*31+name.charCodeAt(i))&0xffff;
  const [a,b]=HOTEL_COLORS[h%HOTEL_COLORS.length]; return `linear-gradient(135deg,${a},${b})`;
}
function hotelInitials(name) {
  return name.split(' ').filter(w=>w.length>2).map(w=>w[0]).join('').slice(0,2).toUpperCase()||name.slice(0,2).toUpperCase();
}

export default function ReportsPage({ user }) {
  const [dateFrom, setDateFrom] = useState(firstOfMonth());
  const [dateTo, setDateTo]     = useState(tomorrow());
  const [hotelId, setHotelId]   = useState('');
  const [mealType, setMealType] = useState('');
  const [tab, setTab]           = useState('all');
  const [hotels, setHotels]     = useState([]);
  const [rows, setRows]         = useState([]);
  const [loading, setLoading]   = useState(false);

  useEffect(() => { api.hotels().then(setHotels); }, []);

  const search = async () => {
    setLoading(true);
    try {
      const p = { date_from: dateFrom, date_to: dateTo };
      if (hotelId)  p.hotel_id  = hotelId;
      if (mealType) p.meal_type = mealType;
      setRows(await api.reports(p));
    } catch(e) { alert(e.message); }
    finally { setLoading(false); }
  };

  const exportExcel = () => {
    const p = { date_from: dateFrom, date_to: dateTo };
    if (hotelId)  p.hotel_id  = hotelId;
    if (mealType) p.meal_type = mealType;
    api.exportExcel(p).catch(e => alert(e.message));
  };

  const filtered = rows.filter(r => {
    if (tab === 'delivery')   return r.service_type === 'delivery' || r.service_type === 'mixed';
    if (tab === 'restaurant') return r.service_type === 'restaurant';
    return true;
  });

  const totals = filtered.reduce((acc, r) => {
    acc[r.meal_type] = (acc[r.meal_type] || 0) + (r.total_qty || 0);
    return acc;
  }, {});
  const grandTotal = Object.values(totals).reduce((a,b) => a+b, 0);

  const channelLabel = (t) => {
    if (t === 'delivery') return <span className="channel-badge channel-delivery">🚚 На доставку</span>;
    if (t === 'restaurant') return <span className="channel-badge channel-restaurant">🍴 В ресторане</span>;
    return <span className="channel-badge channel-mixed">🔀 Смешанный</span>;
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Отчёты по питанию</div>
          <div className="page-subtitle">Аналитика заказов и потребления питания по отелям</div>
        </div>
        <div className="header-actions">
          <button className="btn btn-primary" onClick={() => api.exportExcel({ date_from: dateFrom, date_to: dateTo, ...(hotelId&&{hotel_id:hotelId}), ...(mealType&&{meal_type:mealType}) }).catch(e=>alert(e.message))} disabled={!rows.length}>
            📥 Excel
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="card" style={{ marginBottom:20 }}>
        <div className="form-row" style={{ alignItems:'flex-end' }}>
          <div className="form-group">
            <label>С даты</label>
            <input type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)} />
          </div>
          <div className="form-group">
            <label>По дату</label>
            <input type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Отель</label>
            <select value={hotelId} onChange={e=>setHotelId(e.target.value)}>
              <option value="">Все отели</option>
              {hotels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Тип питания</label>
            <select value={mealType} onChange={e=>setMealType(e.target.value)}>
              <option value="">Все типы</option>
              <option value="breakfast">🥐 Завтрак</option>
              <option value="dinner">🌙 Ужин</option>
              <option value="lunch">🍲 Обед</option>
              <option value="other">☕ Прочее</option>
            </select>
          </div>
          <button className="btn btn-blue" onClick={search} disabled={loading} style={{height:40}}>
            {loading ? 'Загрузка...' : '🔍 Показать'}
          </button>
        </div>
      </div>

      {rows.length > 0 && <>
        {/* Tabs */}
        <div className="tabs">
          <button className={`tab-btn ${tab==='all'?'active':''}`} onClick={()=>setTab('all')}>
            🍽 Все заказы <span style={{fontSize:11,color:'#6b7280'}}>На доставку + В ресторане</span>
          </button>
          <button className={`tab-btn ${tab==='delivery'?'active':''}`} onClick={()=>setTab('delivery')}>
            🚚 На доставку <span style={{fontSize:11,color:'#6b7280'}}>Доставка в номера</span>
          </button>
          <button className={`tab-btn ${tab==='restaurant'?'active':''}`} onClick={()=>setTab('restaurant')}>
            🍴 В ресторане <span style={{fontSize:11,color:'#6b7280'}}>Обслуживание в ресторане</span>
          </button>
        </div>

        {/* Stats */}
        <div className="stats-row" style={{ marginBottom:20 }}>
          {['breakfast','dinner','lunch'].map(t => (
            <div className="stat-card" key={t}>
              <div className={`stat-icon ${t}`}>{t==='breakfast'?'🥐':t==='dinner'?'🌙':'🍲'}</div>
              <div className="stat-body">
                <div className="stat-label">{t==='breakfast'?'Завтраки':t==='dinner'?'Ужины':'Обеды'}</div>
                <div className="stat-value">{totals[t]||0}</div>
              </div>
            </div>
          ))}
          <div className="stat-card">
            <div className="stat-icon closed">📋</div>
            <div className="stat-body">
              <div className="stat-label">Всего</div>
              <div className="stat-value">{grandTotal}</div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="card">
          <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', marginBottom:12, color:'#6b7280', fontSize:13 }}>
            Найдено записей: {filtered.length}
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Дата</th>
                  <th>Отель</th>
                  <th>Тип</th>
                  <th>Записей</th>
                  <th>Порций</th>
                  <th>Из TL</th>
                  <th>Ручных</th>
                  <th>Канал</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((r,i) => (
                  <tr key={i}>
                    <td style={{ fontWeight:600, color:'#374151' }}>{r.date}</td>
                    <td>
                      <div className="hotel-cell">
                        <div className="hotel-cell-avatar" style={{ background: hotelColor(r.hotel_name) }}>
                          {hotelInitials(r.hotel_name)}
                        </div>
                        <div>
                          <div className="hotel-cell-name">{r.hotel_name}</div>
                        </div>
                      </div>
                    </td>
                    <td><span className={`meal-badge ${MEAL_CLS[r.meal_type]||'meal-other'}`}>{MEAL_LABELS[r.meal_type]||r.meal_type}</span></td>
                    <td>{r.records}</td>
                    <td><strong>{r.total_qty}</strong></td>
                    <td><span className="source-tl">{r.from_tl}</span></td>
                    <td><span className="source-manual">{r.manual}</span></td>
                    <td>{channelLabel(r.service_type)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </>}

      {rows.length === 0 && !loading && (
        <div className="card"><div className="empty">Выберите период и нажмите «Показать»</div></div>
      )}
    </div>
  );
}
